import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Session } from '../models/session.interface';
import { DebugLoggerService } from './debug-logger.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private _debugLogger = inject(DebugLoggerService);

  private _session: BehaviorSubject<Session> = new BehaviorSubject<Session>(null);
  public session: Observable<Session> = this._session.asObservable();

  private _userPermission: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public userPermission: Observable<any[]> = this._userPermission.asObservable();

  private _causalRequestUserPermission: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public causalRequestUserPermission: Observable<any[]> = this._causalRequestUserPermission.asObservable();

  constructor() { }

  public setSession(session: any): void {
    this._session.next(session);
    this._debugLogger.reset();
    this._debugLogger.logState('SessionService', 'setSession', session);
  }

  public get getSession(): any {
    return this._session.getValue();
  }

  public get getTimezone(): any {
    return this.getSession.ianaTimezone;
  }

  public get getLanguage(): any {
    return this._session.getValue() ? (this._session.getValue()).defaultLanguage : 'it';
  }

  public get getPartySharedDefaultView(): any {
    return (this._session.getValue()).partySharedViewDefault;
  }

  public get presenceTimeFormat(): any {
    return (this._session.getValue()).presenceTimeEditor;
  }

  public get attendanceValidLULDate(): any {
    return (this._session.getValue()).attendanceValidLULDate;
  }

  public get userName(): any {
    return this._session.getValue() ? (this._session.getValue()).userName : null;
  }

  public get fullName(): any {
    return this._session.getValue() ? (this._session.getValue()).fullName : null;
  }

  public get email(): any {
    return this._session.getValue() ? (this._session.getValue()).email : null;
  }

  public get relationTypologies(): any {
    return this._session.getValue() ? (this._session.getValue()).relationTypologies : null;
  }

  public setUserPermission(userPermission: any): void {
    this._userPermission.next(userPermission);
    this._debugLogger.logState('SessionService', 'setUserPermission', userPermission);
  }

  public get getUserPermission(): any {
    return this._userPermission.getValue();
  }

  public setCausalRequestUserPermission(causalRequestUserPermission: any): void {
    this._causalRequestUserPermission.next(causalRequestUserPermission);
    this._debugLogger.logState('SessionService', 'setCausalRequestUserPermission', causalRequestUserPermission);
  }

  public get causalRequestUserPerm(): any {
    return this._causalRequestUserPermission.getValue();
  }
}
